import React, { Component } from 'react'
import Row from "antd/lib/row";
import Form, {
    FormComponentProps
} from 'antd/lib/form';
import FormScheme, { FormGroup, FormItem, Type } from "../core/FormScheme";
import { SetComponent } from "../core/ComponentRegistor";
import FormItemComponent from "./FormItemComponent";
import FormGroupComponent from "./FormGroupComponent";

import { AntInput } from "../input/Ant-Input";
import { AntTextarea } from "../input/Ant-textarea";
import { AntDropdown } from '../utils/Ant-Dropdown';
import { AntCheckbox } from '../utils/Ant-Checkbox';
import { AntOthers } from '../utils/Ant-Others';
import { AntLogin } from '../input/Ant-Login';
import { AntRegister } from '../input/Ant-Register';
import { AntDiyForm } from '../input/Ant-DiyForm';
import { AntMemu } from '../memu/Ant-Memu';
import { AntDatePick } from '../utils/Ant-DatePick';
import { AntList } from '../utils/Ant-List';
import { AntCheckboxContainer } from '../utils/Ant-CheckboxAntCheckboxContainer';

export class DynamicForm extends Component<{
    formScheme: FormScheme
}> {

    constructor(props) {
        super(props)
        this.state = {

        }
        const formItems = [
            AntInput,
            AntLogin,
            AntRegister,
            AntDiyForm,
            AntTextarea,
            AntDropdown,
            AntCheckbox,
            AntDatePick,
            AntOthers,
            AntMemu,
            AntList,
            AntCheckboxContainer
        ]
        SetComponent(props.formScheme)
        this.state = {
            formScheme: props.formScheme
        }
    }

    static getDerivedStateFromProps(nextProps, prevState): any {
        if (nextProps.formScheme) {
            SetComponent(nextProps.formScheme)
        }
        return null
    }

    render() {
        const formItems = this.props.formScheme.children.map((item: FormItem | FormGroup, index) => {
            if ((item as any).class) {
                return (
                    <FormItemComponent key={item.key} formKey={item.key} name={item.name} class={(item as FormItem).class} {...(item as FormItem).props} {...this.props}></FormItemComponent>
                )
            } else {
                return (
                    <FormGroupComponent key={item.key} formKey={item.key} name={item.name} items={(item as FormGroup).children} {...this.props}></FormGroupComponent>
                );
            }
        })
        return (
            <Form>
                <Row gutter={16}>
                    {formItems}
                </Row>
            </Form>
        )
    }
}
interface AntWfFormProps extends FormComponentProps {
    onSubmit?: (e) => {} | void,
    form: any,
    formScheme: FormScheme,
    formLayout?: string
    onValuesChange?: any
}

export const WrappedDynamicForm = Form.create<AntWfFormProps>({
    name: 'antWfForm',
    onValuesChange: (props, changedValues, allValues) => {
        if (props.onValuesChange) {
            props.onValuesChange(changedValues, allValues)
        }
    }
})(DynamicForm);